/** Босс повержен — представление без стора, всё приходит пропсами. */
import { Button, Icon, Panel, TAP_GUARD_MS, WindowShell, compactCoins } from "../kit";
import { getLocale } from "../../../i18n";
import { useT } from "../../../app";

export interface BossDefeatedViewProps {
  /** Волна босса. */
  wave: number;
  coins: number;
  onNext(): void;
  onShare(): void;
  /** Редактор сторис; нет в браузере и у старого Telegram. */
  onStory?(): void;
  /**
   * «Позови друга» после первого босса; `null` — не показываем. `wave`/`coins` — условия награды, если сервер их знает.
   */
  invite?: { wave?: number; coins?: number } | null;
  onInvite?(): void;
}

export function BossDefeatedView(props: BossDefeatedViewProps) {
  const { wave, coins, onNext, onShare, onStory, invite = null, onInvite } = props;
  const locale = getLocale();
  const t = useT();
  return (
    <WindowShell kind="bossDefeated" title={t("win.boss.title")} guardMs={TAP_GUARD_MS}>
      {/* место под сундук v2 не рисуем: в v1 награда — только монеты */}
      <div class="win-row">
        <Panel class="win-stat win-stat--wide" testid="boss-coins">
          <Icon name="coin" size={40} />
          <span class="win-stat__value">+{compactCoins(coins, locale)}</span>
          <span class="win-stat__label">{t("win.boss.reward")}</span>
        </Panel>
      </div>
      {invite && (
        <Panel class="win-revive" testid="boss-invite">
          <b class="win-revive__title">{t("win.boss.inviteTitle")}</b>
          <p class="win-note">
            {invite.wave && invite.coins
              ? t("win.boss.inviteReward", { wave: invite.wave, coins: compactCoins(invite.coins, locale) })
              : t("win.boss.inviteNote")}
          </p>
          <Button tone="blue" onClick={() => onInvite?.()} data-testid="boss-invite-button">
            <Icon name="share" size={20} /> {t("win.boss.invite")}
          </Button>
        </Panel>
      )}
      <div class="win-actions">
        <Button tone="green" onClick={onNext} data-testid="boss-next">
          <Icon name="play" size={20} /> {t("win.boss.next", { n: wave + 1 })}
        </Button>
        <Button tone="blue" onClick={onShare} data-testid="boss-share">
          <Icon name="share" size={20} /> {t("win.boss.share")}
        </Button>
        {onStory && (
          <Button tone="blue" onClick={onStory} data-testid="boss-story">
            <Icon name="share" size={20} /> {t("win.boss.story")}
          </Button>
        )}
      </div>
    </WindowShell>
  );
}
